const urls = {
  // 采购人档案
  ClPurchase: {
    GetPaged: '/api/services/app/ClPurchase/GetPaged',
    GetById: '/api/services/app/ClPurchase/GetById',
    CreateOrUpdate:'/api/services/app/ClPurchase/CreateOrUpdate',
    GetAMCount: '/api/services/app/ClPurchase/GetAMCount',
    GetAmClientQuota: '/api/services/app/User/GetAmClientQuota',
    PostAMCount: '/api/services/app/ClPurchase/PostAMCount'
  },
  // 采购人拜访记录
  CLCustomerVisit: {
    getPurchaserVisitList: '/api/services/app/CLCustomerVisit/GetPaged'
  },
  CLDistrict: {
    GetList: '/api/services/app/CLDistrict/GetList',
    GetListWithoutRole: '/api/services/app/CLDistrict/GetListWithoutRole'
  },
  Session: {
    GetCurrentUser: '/api/services/app/Session/GetCurrentUser'
  }
}
export default urls